<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <layouts></layouts>
      <sidebar-menu></sidebar-menu>
      <div class="page-wrapper">
        <div class="content">
          <pageheader :title="title" :title1="title1" />
  
          <!-- /add -->
          <div class="card">
            <div class="card-body">
              <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
              <form @submit.prevent="insert">
                <div class="row">
                 
                  <div class="col-12">
                    <div class="form-group w-100">
                      <label>Excel File <span class="text-danger">*</span></label>
                      <input type="file" class="form-control" ref="sqlite_file" accept=".xlsx" required />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <button type="submit" class="btn btn-submit me-2">Import</button>
                    <router-link to="schedule" class="btn btn-cancel">Cancel</router-link>
                  </div>
                </div>
  
              </form>

              <div class="row mt-3 mx-2" v-if="dataSuccess.length > 0">
                <div class="card">
                    <div class="card-body">
                        <ul v-for="item in dataSuccess" :key="index">
                            <li>{{ item }}</li>
                        </ul>
                    </div>
                </div>
              </div>


            </div>
          </div>
          <!-- /add -->
        </div>
      </div>
    </div>
  </template>
  <script>
  import Cookies from "js-cookie";
  import axios from "axios";
  import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch } from "@/assets/js/function";
  
  // import { Form, Field } from "vee-validate";
  // import * as Yup from "yup";
  
  export default {
    // components: {
    //   Form,
    //   Field,
    // },
    name: "editemployee",
    data() {
      return {
        filter: true,
        title: "Import Schedule",
        title1: "manage your employees schedule",
        config: "",
        api: "",
  
        //data
        currentData: {},

        dataSuccess: [],
        currentDate: new Date,
        startDate: new Date,
        endDate: new Date,
      };
    },
  
    created() {
      const token = Cookies.get("token_refresh");
      this.config = {
        headers: {
          Authorization: `Bearer ` + token,
        },
        timeout: 30000,
      }
  
    },
    
    methods: {
  
      getNameFileUrl(url) {
        const parts = url.split('/');
        const fileName = parts[parts.length - 1];
        return fileName;
      },

      async insert() {
       
        let formData = new FormData();
        appendForm(formData)
  
        Object.entries(this.currentData).forEach(([key, value]) => {
          formData.append(key, value);
        });
  
        formData.append("excelFile", this.$refs.sqlite_file.files[0]);

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // return true
  

        const api = base_url + '/v3/schedule/import';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
  
        this.dataSuccess = []

        if(data.status){
            AlertBottom(data.message);
              
            this.dataSuccess = data.data
            // goPage('historyattendance')
            CloseLoading();

        }else {
            AlertPopup2("error", "", data.message || "Unknown error", true, 1500);
        }
        
        
      },
  
    },
  
  };
  </script>
  